import { color } from 'asserts/styles/colors';
import DefaultButton from 'components/button/DefaultButton';
import { ButtonWrapper, InputWrapper } from 'components/customer/Reference';
import DefaultInput from 'components/input/DefaultInput';
import styled from 'styled-components';

const FAQSkeleton = () => {
  return (
    <Wrapper>
      <ButtonWrapper className="button">
        {Array(4)
          .fill(null)
          .map((_, index) => (
            <DefaultButton key={index} text="" loading />
          ))}
      </ButtonWrapper>
      <InputWrapper>
        <DefaultInput name="search" search height="middle" />
      </InputWrapper>
      <InnerWrppaer>
        {Array(5)
          .fill(null)
          .map((_, index) => (
            <DataWrapper key={index}>
              <div></div>
              <div></div>
            </DataWrapper>
          ))}
      </InnerWrppaer>
    </Wrapper>
  );
};

export default FAQSkeleton;

export const DataWrapper = styled.div`
  display: flex;
  gap: 16px;
  padding: 24px 32px;
  border-radius: 12px;
  border: 1px solid ${color.gray200};
  background: ${color.white};

  div {
    width: var(--Space-5XL, 64px);
    align-self: stretch;
    height: 22px;
    background: ${color.gray200};
    border-radius: 8px;
  }

  div:last-of-type {
    flex: 1 0 0;
    align-self: stretch;
  }
`;

const InnerWrppaer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Wrapper = styled.div`
  & div.button {
    & p:nth-child(2) button {
      width: 98px;
    }

    & p:nth-child(3) button,
    & p:nth-child(4) button {
      width: 118px;
    }
  }
`;
